export default "__VITE_ASSET__72a339c1__"